import SearchCarHireForm from './SearchCarHireForm'

export default SearchCarHireForm
